module.exports = __webpack_public_path__ + "img/3patti.4b5715c0.jpg";